import React from 'react'
import { Link } from 'react-router-dom'

export default function Navi() {
    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-light bg-light" id="navi">
                <Link to='/'><a className="navbar-brand" href="/#">JA Creation</a></Link>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav"  aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ml-auto">
                        <Link to='/'>
                            <li className="nav-item active">
                                <a className="nav-link" href="/#">Home <span className="sr-only">(current)</span></a>
                            </li>
                        </Link>
                        <Link to='/about'>
                            <li className="nav-item">
                                <a className="nav-link" href="/#">About</a>
                            </li>
                        </Link>

                        <Link to='/services'>
                            <li className="nav-item">
                                <a className="nav-link" href="/#">Services</a>
                            </li>
                        </Link>

                        <Link to='/contact_us'>
                            <li className="nav-item">
                                <a className="nav-link" href="/#">Contact Us</a>
                            </li>
                        </Link>
                        
                    </ul>
                </div>
            </nav>
        </div>
    )
}
